/*
 *
 * NetworkCards actions
 *
 */
import * as reqHandler from '../../config/services/serviceHandler';
import endpoint from '../../config/endPoints';
import {
  rootApiResponse,
  clearDefaultError,
  GET_REQ_HANDLER,
  getUpdatedUserProfile,
} from '../HeaderContainer/actions';
import {
  isImmutableLoggedIn,
  successResponse,
  errorResponse,
  // addAuthHeaders,
  // removeAuthHeaders,
} from '../../devUtils/commonUtils';
import {
  DEFAULT_ACTION,
  FETCH_TRANSACTIONS_SUCCESS,
  SET_CARD_BLOCK_SUCCESS,
  SET_REPORT_SUCCESS,
  SET_CARD_REMOVE_SUCCESS,
  SET_POS_OTP_SEND_SUCCESS,
  SET_CARD_PIN_RESET_SUCCESS,
  GetActiveCardDetails,
  GetCustomAlert,
  SET_REQUEST_INTERNET_PIN,
  NETWORKCARD_CONSTANTS,
  SET_REPORT_STATEMENT_SUCCESS,
  SET_NSDL_M2P_STATEMENT_SUCCESS,
  SET_NSDL_ISG_STATEMENT_SUCCESS,
  SET_NSDL_M2P_REPLACE_CARD_SUCCESS,
  SET_NSDL_M2P_BLOCK_CARD_SUCCESS,
  WALLET_TO_IMPS_TRANSFER_SUCCESS,
  SET_IPIN_OTP_SUCCESS,
  RESET_PASSWORD_SUCCESS,
  SET_IPIN_SUCCESS,
  UNLOCK_CARD_OTP_SUCCESS,
  YBL_DELETE_BENEFICIARY_SUCCESS,
  GET_OTP_SUCCESS,
  SET_CHANNEL_FLAG_SUCCESS,
  FETCH_CARD_DATA_YSC,
  FETCH_CARD_DATA_YBL,
  FETCH_CARD_DATA_NSDL,
} from './constants';
import { utils, constants, eventTracking } from '../../devUtils';
import { BLOCK_CARD_OTP_SUCCESS } from '../YscCardActions/constants';

// const defaultAction = () => ({ type: DEFAULT_ACTION });
const fetchTransactionsSuccess = (payload) => ({ type: FETCH_TRANSACTIONS_SUCCESS, payload });
const blockCardSuccess = (payload) => ({ type: SET_CARD_BLOCK_SUCCESS, payload });
const reportGenerateSuccess = (payload) => ({ type: SET_REPORT_SUCCESS, payload });
const fetchCardDataYscSuccess = (payload) => ({ type: FETCH_CARD_DATA_YSC, payload });
const fetchCardDataYblSuccess = (payload) => ({ type: FETCH_CARD_DATA_YBL, payload });
const fetchCardDataNsdlSuccess = (payload) => ({ type: FETCH_CARD_DATA_NSDL, payload });
export const removeCardSuccess = (payload) => ({ type: SET_CARD_REMOVE_SUCCESS, payload });
const posOtpSendSuccess = (payload) => ({ type: SET_POS_OTP_SEND_SUCCESS, payload });
const cardPinResetSuccess = (payload) => ({ type: SET_CARD_PIN_RESET_SUCCESS, payload });
const yesRequestStatementGenerateSuccess = (payload) => ({ type: SET_REPORT_STATEMENT_SUCCESS, payload });
const nsdlM2pRequestStatementSuccess = (payload) => ({ type: SET_NSDL_M2P_STATEMENT_SUCCESS, payload });
const nsdlIsgRequestStatementSuccess = (payload) => ({ type: SET_NSDL_ISG_STATEMENT_SUCCESS, payload });
const replaceCardSuccessM2p = (payload) => ({ type: SET_NSDL_M2P_REPLACE_CARD_SUCCESS, payload });
const blockCardSuccessM2p = (payload) => ({ type: SET_NSDL_M2P_BLOCK_CARD_SUCCESS, payload });
const yblVerifyLimitOtpSuccess = (payload) => ({ type: NETWORKCARD_CONSTANTS.SET_YBL_VERIFY_LIMIT_OTP, payload });
const walletToImpsTransferSuccess = (payload) => ({ type: WALLET_TO_IMPS_TRANSFER_SUCCESS, payload });
const fetchYblOtpSuccess = (payload) => ({ type: NETWORKCARD_CONSTANTS.SET_YBL_OTP_SUCCESS, payload });
const fetchYblOtpVerifySuccess = (payload) => ({ type: NETWORKCARD_CONSTANTS.SET_YBL_OTP_VERIFIED, payload });
const setIpinSuccess = (payload) => ({ type: SET_IPIN_SUCCESS, payload });
const resetPasswordSuccess = (payload) => ({ type: RESET_PASSWORD_SUCCESS, payload });
const ipinOtpSendSuccess = (payload) => ({ type: SET_IPIN_OTP_SUCCESS, payload });
const blockCardOtpSendSuccess = (payload) => ({ type: BLOCK_CARD_OTP_SUCCESS, payload });
const unlockCardOtpSuccess = (payload) => ({ type: UNLOCK_CARD_OTP_SUCCESS, payload });
const yblDeleteBeneficiarySuccess = (payload) => ({ type: YBL_DELETE_BENEFICIARY_SUCCESS, payload });
const getOtpSuccess = (payload) => ({ type: GET_OTP_SUCCESS, payload });
const setChannelFlagSuccess = (payload) => ({ type: SET_CHANNEL_FLAG_SUCCESS, payload });


const fetchCardData = (id, location = {}) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const loggedIn = isImmutableLoggedIn(getState);
    if (loggedIn) {
      const authPrerequist = utils.getAuthPrerequist(getState, true);
      let res = null;
      if (['physical', 'virtual'].includes(id)) {
        if ((location.pathname).includes(constants.YES_BANK_PHYSICAL) || (location.pathname).includes(constants.YES_BANK_VIRTUAL)) {
          res = await reqHandler.getHandler(api, endpoint.GET_WALLET_BALANCE_V3, {}, authPrerequist);
          if (res && res.status) {
            return dispatch(fetchCardDataYblSuccess(res));
          }
        } else if ((location.pathname).includes(constants.NSDL_PHYSICAL) || (location.pathname).includes(constants.NSDL_VIRTUAL)) {
          res = await reqHandler.getHandler(api, endpoint.GET_WALLET_M2P_BALANCE, {}, authPrerequist);
          res = GetActiveCardDetails(res, id);
          if (res && res.status) {
            return dispatch(fetchCardDataNsdlSuccess(res));
          }
        }
      } else {
        res = await reqHandler.postHandler(api, endpoint.GET_YSC_CARD_DETAIL, { ysc_card_id: id }, authPrerequist);
        res.status = true;
        if (res && res.status) {
          return dispatch(fetchCardDataYscSuccess(res));
        }
      }
      throw (res.message);
    }
    throw (constants.ALERT_LOGIN_REQUIRED);
  } catch (err) {
    dispatch(fetchCardDataYscSuccess({ status: false }));
    dispatch(fetchCardDataNsdlSuccess({ status: false }));
    dispatch(fetchCardDataYblSuccess({ status: false }));
    return dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
  }
};


const fetchTransactions = (payload, location) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const loggedIn = isImmutableLoggedIn(getState);
    if (loggedIn) {
      const authPrerequist = utils.getAuthPrerequist(getState, true);
      let response = { status: false };
      if (['physical', 'virtual'].includes(payload.ysc_card_id)) {
        if ((location.pathname).includes(constants.NSDL_PHYSICAL) || (location.pathname).includes(constants.NSDL_VIRTUAL)) {
          response = await reqHandler.postHandler(api, endpoint.POST_TRANSACTION_HISTORY_NSDL, payload, authPrerequist);
        } else if ((location.pathname).includes(constants.YES_BANK_PHYSICAL) || (location.pathname).includes(constants.YES_BANK_VIRTUAL)) {
          response = await reqHandler.getHandler(api, endpoint.GET_TRANSACTION_HISTORY_V3, payload, authPrerequist);
        }
      } else {
        response = await reqHandler.postHandler(api, endpoint.GET_YSC_CARD_TRANSACTIONS, payload, authPrerequist);
      }
      return dispatch(fetchTransactionsSuccess({ ...response, ts: Date.now() }));
    }
    throw (constants.ALERT_LOGIN_REQUIRED);
  } catch (err) {
    return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
  }
};

/**
 * @desc this will trigger the OTP
 */

export const blockCard = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const loggedIn = isImmutableLoggedIn(getState);
    if (loggedIn) {
      const authPrerequist = utils.getAuthPrerequist(getState, true);
      const response = await reqHandler.postHandler(api, endpoint.BLOCK_YSC_CARD, payload, authPrerequist);
      dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, response.message)));
      await new Promise((resolve) => setTimeout(resolve, 1000));
      dispatch(blockCardSuccess(response));
      return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    }
    throw (constants.ALERT_LOGIN_REQUIRED);
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    return dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
  }
};

export const reportGenerate = (payload, cardName) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.postHandler(api, endpoint.POST_CARD_STATEMENT, payload, authPrerequist);
    dispatch(reportGenerateSuccess(true));
    eventTracking.triggerEvent('Manage Network Cards', 'Request Statement', `<${cardName}>--<Success>`);
    dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, response.message)));
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    eventTracking.triggerEvent('Manage Network Cards', 'Request Statement', `<${cardName}>--<Failure>`);
    dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err, 'popup')));
  }
};


export const removeCard = (payload, cardName) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.postHandler(api, endpoint.REMOVE_CARD_YSC, payload, authPrerequist);
    // const response = await { "message": "Card successfully removed", "errors": [] };
    if (response.errors && response.errors.length > 0) {
      throw (response.message);
    } else {
      dispatch(removeCardSuccess(true));
      dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, response.message)));
      eventTracking.triggerEvent('Manage Network Cards', 'Remove Card', `<${cardName}>--<Success>`);
    }
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    eventTracking.triggerEvent('Manage Network Cards', 'Remove Card', `<${cardName}>--<Failure>`);
    dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err, 'popup')));
  }
};

const updateInternetPin = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    dispatch(cardPinResetSuccess({ isSuccess: false, isLoading: true }));
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.postHandler(api, endpoint.POST_CHANGE_INTERNET_PIN, payload, authPrerequist);
    if (response.status) {
      dispatch(cardPinResetSuccess({ isSuccess: true }));
      dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, constants.ALERT_PIN_UPDATED)));
      eventTracking.triggerEvent('Manage Network Cards', 'Update Ipin', '<Success>');
    } else {
      dispatch(cardPinResetSuccess({ isSuccess: false }));
      throw constants.ALERT_DEFAULT_ERROR;
    }
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err, 'popup')));
    eventTracking.triggerEvent('Manage Network Cards', 'Update Ipin', '<Failure>');
  }
};

const initPosPinReset = (payload, otherParams) => async (dispatch, getState, api) => {
  const { otp_type } = otherParams;
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.postHandler(api, endpoint.POST_GENERATE_OTP, { ...payload, otp_type }, authPrerequist);
    if (response && response.status) {
      if (otp_type === 'pos_pin_set') {
        dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, response.message)));
        await new Promise((resolve) => setTimeout(resolve, 1000));
        dispatch(posOtpSendSuccess(true));
        return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
      }
      if (otp_type === 'permanent_block_ysc_card') {
        dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, response.message)));
        await new Promise((resolve) => setTimeout(resolve, 1000));
        dispatch(blockCardOtpSendSuccess(response));
        return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
      }
      dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, response.message)));
      await new Promise((resolve) => setTimeout(resolve, 1000));
      dispatch(ipinOtpSendSuccess(response));
      return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    }
    throw response.message;
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    return dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
  }
};

const initPosPinResetNSDL = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    dispatch(cardPinResetSuccess({ isSuccess: false }));
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.postHandler(api, endpoint.POST_WALLET_M2P_SET_PIN, payload, authPrerequist);
    if (response.status) {
      dispatch(cardPinResetSuccess({ isSuccess: true }));
      dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, constants.ALERT_PIN_UPDATED)));
    } else {
      throw constants.ALERT_DEFAULT_ERROR;
    }
  } catch (err) {
    dispatch(cardPinResetSuccess({ isSuccess: false }));
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err, 'popup')));
  }
};

const posPinResetSubmit = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.postHandler(api, endpoint.POST_RESET_PIN, payload, authPrerequist);
    if (response.status) {
      dispatch(cardPinResetSuccess({ isSuccess: true }));
      dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, constants.ALERT_PIN_UPDATED)));
      eventTracking.triggerEvent('Manage Network Cards', 'POS Pin Reset', '<Success>');
    } else {
      throw constants.ALERT_DEFAULT_ERROR;
    }
  } catch (err) {
    dispatch(cardPinResetSuccess({ isSuccess: false }));
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err, 'popup')));
    eventTracking.triggerEvent('Manage Network Cards', 'POS Pin Reset', '<Failure>');
  }
};

const SetChannelFlag = (payload, otherParams) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const URL = otherParams.type === 'ACTIONS' ? endpoint.POST_PHYSICAL_CARD_ACTIONS_V3 : endpoint.POST_CHANNEL_FLAG_V3;
    const response = await reqHandler.postHandler(api, URL, payload, authPrerequist);
    const response_url = (response && response.data && response.data.length && response.data[0].url) || '';
    if (response && response.status && !response_url && payload.action_type !== 'replace') {
      dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, response.message)));
      await new Promise((resolve) => setTimeout(resolve, 4000));
      const res = GetActiveCardDetails(response, otherParams.cardType);
      dispatch(setChannelFlagSuccess(res));
    } else if (response && response.status && response_url) {
      utils.getWindowInstance().location.href = response_url;
    } else if (response && response.status && !response_url && payload.action_type === 'replace') {
      dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    } else {
      throw response.message;
    }
    dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, GetCustomAlert(payload, response))));
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
  }
};

const SetRequestInternetPin = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.postHandler(api, endpoint.POST_REQUEST_IPIN, payload, authPrerequist);
    if (response.status) {
      dispatch({ type: SET_REQUEST_INTERNET_PIN, payload: { ...response, ts: Date.now() } });
      return dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, response.message)));
    }
    throw (response.message);
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    return dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
  }
};

const SetComplainModule = (payload, otherParams) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const { actionType, apiMethod, history } = otherParams;
    let URL;
    switch (actionType) {
      case 'TYPE_LIST':
        URL = endpoint.GET_COMPLAINT_TYPES;
        break;
      case 'LISTING':
      case 'CREATE':
        URL = endpoint.COMPLAINT;
        break;
      default:
        break;
    }
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await GET_REQ_HANDLER(apiMethod)(api, URL, payload, authPrerequist);
    if (response.status) {
      switch (actionType) {
        case 'TYPE_LIST':
          return dispatch({ type: NETWORKCARD_CONSTANTS.SET_COMPLAIN_TYPE_LIST, payload: response });
        case 'CREATE': {
          if (history) {
            return utils.forceRedirect(history, { pathname: constants.CONTANTS.COMPLAINT_MODULE });
          }
          dispatch({ type: NETWORKCARD_CONSTANTS.SET_COMPLAIN_CREATE, payload: response });
          return dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, response.message)));
        }
        case 'LISTING':
          return dispatch({ type: NETWORKCARD_CONSTANTS.SET_COMPLAIN_LIST, payload: response });
        default:
          break;
      }
    }
    throw response.message;
  } catch (err) {
    dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
    return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
  }
};

// Transfer, Edit and Add new Beneficiary and OTP Verification
const SetFundTransfer = (payload, otherParams) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const { actionType, apiMethod } = otherParams;
    let URL;
    switch (actionType) {
      case 'LISTING':
        URL = endpoint.GET_BENEFICIARIES_V3;
        break;
      case 'VIEW':
        URL = endpoint.POST_UPDATE_BENEFICIARY_V3;
        break;
      case 'CREATE':
        URL = endpoint.POST_BENEFICIARIES_V3;
        break;
      case 'UPDATE':
        URL = endpoint.POST_UPDATE_BENEFICIARIES_V3;
        break;
      case 'TRANSFER':
        URL = endpoint.POST_IMPS_TRANSFER_V3;
        break;
      default:
        break;
    }
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await GET_REQ_HANDLER(apiMethod)(api, URL, payload, authPrerequist);
    if (response.status) {
      switch (actionType) {
        case 'UPDATE':
        case 'TRANSFER':
        case 'CREATE': {
          if (actionType === 'CREATE') {
            dispatch(SetFundTransfer({}, { actionType: 'LISTING', apiMethod: 'GET' }));
            await new Promise((resolve) => setTimeout(resolve, 1500));
            return dispatch({ type: NETWORKCARD_CONSTANTS.SET_BENEFICIARIES_CREATE_NEW, payload: { ...response, ts: Date.now() } });
          } else if (actionType === 'TRANSFER') {
            dispatch(SetFundTransfer({}, { actionType: 'LISTING', apiMethod: 'GET' }));
            await new Promise((resolve) => setTimeout(resolve, 2000));
            return dispatch({ type: NETWORKCARD_CONSTANTS.SET_YES_BANK_TRANSFER, payload: { ...response, ts: Date.now() } });
          }
          dispatch(getUpdatedUserProfile());
          dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, response.message)));
          await new Promise((resolve) => setTimeout(resolve, 2000));
          return dispatch({ type: NETWORKCARD_CONSTANTS.SET_BENEFICIARIES_CREATE, payload: { ...response, ts: Date.now() } });
        }
        case 'LISTING':
          return dispatch({ type: NETWORKCARD_CONSTANTS.SET_BENEFICIARIES_LIST, payload: response });
        case 'VIEW':
          return dispatch({ type: NETWORKCARD_CONSTANTS.SET_BENEFICIARY_VIEW, payload: response });
        default:
          break;
      }
    }
    throw response.message;
  } catch (err) {
    dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
    return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
  }
};

const SetNsdlFundTransfer = (payload, otherParams) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const { actionType, apiMethod } = otherParams;
    let URL;
    switch (actionType) {
      case 'LISTING':
        URL = endpoint.POST_NSDL_BENEFICIARIES;
        break;
      case 'VIEW':
        URL = endpoint.POST_NSDL_FETCH_BENEFICIARY;
        break;
      case 'CREATE':
        URL = endpoint.POST_NSDL_ADD_BENEFICIARY;
        break;
      case 'UPDATE':
        URL = endpoint.POST_NSDL_UPDATE_BENEFICIARIES;
        break;
      case 'TRANSFER':
        URL = endpoint.POST_IMPS_M2P_TRANSFER;
        break;
      case 'DELETE':
        URL = endpoint.POST_M2P_DELETE_BENEFICIARY;
        break;
      default:
        break;
    }
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await GET_REQ_HANDLER(apiMethod)(api, URL, payload, authPrerequist);
    if (response.status) {
      switch (actionType) {
        case 'UPDATE':
        case 'TRANSFER':
        case 'DELETE':
        case 'CREATE': {
          if (['CREATE', 'DELETE', 'UPDATE'].includes(actionType)) {
            dispatch(SetNsdlFundTransfer({}, { actionType: 'LISTING', apiMethod: 'POST' }));
          }
          dispatch(getUpdatedUserProfile());
          dispatch({ type: NETWORKCARD_CONSTANTS.SET_NSDL_BENEFICIARIES_CREATE, payload: { ...response, ts: Date.now() } });
          return dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, response.message)));
        }
        case 'LISTING':
          return dispatch({ type: NETWORKCARD_CONSTANTS.SET_NSDL_BENEFICIARIES_LIST, payload: response });
        case 'VIEW':
          return dispatch({ type: NETWORKCARD_CONSTANTS.SET_NSDL_BENEFICIARY_VIEW, payload: response });
        default:
          break;
      }
    }
    throw response.message;
  } catch (err) {
    dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
    return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
  }
};


const setNsdlChannelFlag = (payload, otherParams = {}) => async (dispatch, getState, api) => {
  const {
    type = '',
    cardType = '',
  } = otherParams;
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const URL = ['NSDLACTIONS', 'BLOCKCARD'].includes(type) ? endpoint.POST_WALLET_M2P_LOCK_UNLOCK : '';
    const response = await reqHandler.postHandler(api, URL, payload, authPrerequist);
    if (response && response.status && !response.url && payload.action_type !== 'replace' && type !== 'BLOCKCARD') {
      let res = await reqHandler.getHandler(api, endpoint.GET_WALLET_M2P_BALANCE, {}, authPrerequist);
      res = GetActiveCardDetails(res, cardType);
      dispatch(fetchCardDataNsdlSuccess(res));
    } else if (response && response.status && response.url) {
      utils.getWindowInstance().location.href = response.url;
    } else if (response && response.status && !response.url && payload.action_type === 'replace') {
      dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    } else if (response && response.status && type === 'BLOCKCARD') {
      dispatch(blockCardSuccessM2p(response));
    } else {
      throw response.message;
    }
    dispatch(rootApiResponse(successResponse(response.DEFAULT_ACTION, response.message, payload)));
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
  }
};

const GenerateOtp = (payload, otherParams) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const URL = otherParams.type === 'ACTIONS' ? endpoint.GET_OTP_FOR_POS_PIN_NSDL : endpoint.GET_OTP_FOR_POS_PIN_NSDL;
    const response = await reqHandler.getHandler(api, URL, payload, authPrerequist);
    if (response && response.status && payload.action_type !== 'generate_otp') {
      const res = GetActiveCardDetails(response, otherParams.cardType);
      dispatch(fetchCardDataNsdlSuccess(res));
    } else if (response && response.status && payload.action_type === 'generate_otp') {
      dispatch({ type: NETWORKCARD_CONSTANTS.SET_GENERATE_OTP_NSDL, payload: { ...response, ts: Date.now() } });
      dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    } else {
      throw response.message;
    }
    dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, GetCustomAlert(payload, response))));
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
  }
};

export const yesRequestStatementGenerate = (payload, cardName) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.postHandler(api, endpoint.POST_YES_BANK_CARD_STATEMENT, payload, authPrerequist);
    dispatch(yesRequestStatementGenerateSuccess(response));
    eventTracking.triggerEvent('Manage Network Cards', 'Request Statement', `<${cardName}>--<Success>`);
    dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, response.message)));
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    eventTracking.triggerEvent('Manage Network Cards', 'Request Statement', `<${cardName}>--<Failure>`);
    dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err, 'popup')));
  }
};

export const nsdlM2pRequestStatement = (payload, cardName) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.postHandler(api, endpoint.POST_NSDL_M2P_REQUEST_STATEMENT, payload, authPrerequist);
    dispatch(nsdlM2pRequestStatementSuccess(response));
    eventTracking.triggerEvent('Manage Network Cards', 'Request Statement', `<${cardName}>--<Success>`);
    dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, response.message)));
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    eventTracking.triggerEvent('Manage Network Cards', 'Request Statement', `<${cardName}>--<Failure>`);
    dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err, 'popup')));
  }
};

export const nsdlIsgRequestStatement = (payload, cardName) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.postHandler(api, endpoint.POST_NSDL_ISG_REQUEST_STATEMENT, payload, authPrerequist);
    dispatch(nsdlIsgRequestStatementSuccess(response));
    eventTracking.triggerEvent('Manage Network Cards', 'Request Statement', `<${cardName}>--<Success>`);
    dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, response.message)));
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    eventTracking.triggerEvent('Manage Network Cards', 'Request Statement', `<${cardName}>--<Failure>`);
    dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err, 'popup')));
  }
};

const m2pReplaceCard = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.postHandler(api, endpoint.POST_NSDL_M2P_REPLACE_CARD, payload, authPrerequist);
    if (response && response.status) {
      dispatch(utils.isReducerLoading(DEFAULT_ACTION));
      dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, response.message)));
      return dispatch(replaceCardSuccessM2p(response));
    }
    throw response.message;
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    return dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
  }
};

const yblVerifyLimitOtp = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.postHandler(api, endpoint.POST_YBL_VERIFY_LIMIT_OTP_V3, payload, authPrerequist);
    if (response && response.status && response.message) {
      dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, response.message)));
      await new Promise((resolve) => setTimeout(resolve, 2000));
      dispatch(utils.isReducerLoading(DEFAULT_ACTION));
      return dispatch(yblVerifyLimitOtpSuccess(response));
    }
    throw response.message;
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    return dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
  }
};

const getDriverSalaryDetails = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.getHandler(api, endpoint.GET_BENEFICIARIES_V3, payload, authPrerequist);
    if (response && response.status) {
      return dispatch({ type: NETWORKCARD_CONSTANTS.SET_BENEFICIARIES_LIST, payload: response });
    }
    throw response.message;
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    return dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
  }
};

const walletToImpsTransfer = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.postHandler(api, endpoint.POST_WALLET_TO_IMPS_V3, payload, authPrerequist);
    if (response && response.status) {
      dispatch(walletToImpsTransferSuccess(response));
      return dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, response.message)));
    }
    throw response.message;
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    return dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
  }
};

const yblOtpGeneration = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.postHandler(api, endpoint.POST_WALLET_REGISTER, payload, authPrerequist);
    if (response && response.status) {
      dispatch(rootApiResponse(utils.successResponse(DEFAULT_ACTION, response.message)));
      await new Promise((resolve) => setTimeout(resolve, 2000));
      dispatch(fetchYblOtpSuccess(response));
      return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    }
    throw (response.message);
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    return dispatch(rootApiResponse(utils.errorResponse(DEFAULT_ACTION, err)));
  }
};

const setIpin = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.postHandler(api, endpoint.POST_NARADA_SET_IPIN, payload, authPrerequist);
    if (response && response.status) {
      dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, response.message)));
      await new Promise((resolve) => setTimeout(resolve, 1000));
      dispatch(setIpinSuccess(response));
      return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    }
    throw response.message;
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    return dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
  }
};

const yblOtpVerify = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.postHandler(api, endpoint.POST_WALLET_VERIFY_OTP, payload, authPrerequist);
    if (response && response.status) {
      dispatch(rootApiResponse(utils.successResponse(DEFAULT_ACTION, response.message)));
      await new Promise((resolve) => setTimeout(resolve, 2000));
      return dispatch(fetchYblOtpVerifySuccess(response));
    }
    throw (response.message);
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    return dispatch(rootApiResponse(utils.errorResponse(DEFAULT_ACTION, err)));
  }
};

const resetPassword = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.postHandler(api, endpoint.POST_NARADA_RESET_PASSWORD, payload, authPrerequist);
    if (response && response.status) {
      dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, response.message)));
      return dispatch(resetPasswordSuccess(response));
    }
    throw response.message;
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    return dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
  }
};

// Deleting Yes Bank Beneficiary and OTP Verification
const yblDeleteBeneficiary = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.postHandler(api, endpoint.POST_YESBANK_DELETE_BENEFICIARY_V3, payload, authPrerequist);
    if (response && response.status) {
      dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, response.message)));
      await new Promise((resolve) => setTimeout(resolve, 2000));
      dispatch(yblDeleteBeneficiarySuccess(response));
      return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    }
    throw response.message;
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    return dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
  }
};

/**
 * @desc this will trigger the OTP
 */

const unlockCard = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const loggedIn = isImmutableLoggedIn(getState);
    if (loggedIn) {
      const authPrerequist = utils.getAuthPrerequist(getState, true);
      const response = await reqHandler.postHandler(api, endpoint.POST_UNLOCK_YSC_CARD, payload, authPrerequist);
      dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, response.message)));
      await new Promise((resolve) => setTimeout(resolve, 1000));
      dispatch(unlockCardOtpSuccess(response));
      return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    }
    throw (constants.ALERT_LOGIN_REQUIRED);
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    return dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
  }
};

const getOtp = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.postHandler(api, endpoint.POST_YES_BANK_OTP_V3, payload, authPrerequist);
    if (response && response.status) {
      dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, response.message)));
      await new Promise((resolve) => setTimeout(resolve, 2000));
      dispatch(getOtpSuccess(response));
      return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    }
    throw response.message;
  } catch (err) {
    dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
    return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
  }
};

export {
  updateInternetPin,
  initPosPinReset,
  posPinResetSubmit,
  posOtpSendSuccess,
  cardPinResetSuccess,
  fetchCardData,
  fetchTransactions,
  SetChannelFlag,
  SetRequestInternetPin,
  SetComplainModule,
  SetFundTransfer,
  setNsdlChannelFlag,
  initPosPinResetNSDL,
  SetNsdlFundTransfer,
  GenerateOtp,
  m2pReplaceCard,
  yblVerifyLimitOtp,
  getDriverSalaryDetails,
  walletToImpsTransfer,
  yblOtpGeneration,
  yblOtpVerify,
  setIpin,
  resetPassword,
  unlockCard,
  yblDeleteBeneficiary,
  getOtp,
};



// WEBPACK FOOTER //
// client/containers/NetworkCards/actions.js